import { render } from "./Trade.vue?vue&type=template&id=4ea4ae2c&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"

import "./Trade.vue?vue&type=style&index=0&id=4ea4ae2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea4ae2c"]])

export default __exports__